import { Button, DataSource, Label, Layout, LayoutHeader, Panel, Splitter, Table } from "@mcleod/components";

export abstract class AutogenLayoutCashReceiptsProcessing extends Layout {
    buttonImport: Button;
    buttonProcess: Button;
    labelTitle: Label;
    layoutheaderCahsReceiptsProcessing: LayoutHeader;
    panelHeader: Panel;
    panelMain: Panel;
    panelTitles: Panel;
    sourceCashReceipt: DataSource;
    sourceDeposits: DataSource;
    splitterReceipts: Splitter;
    tableCashReceipts: Table;
    tableDeposits: Table;
}
